import UpdateAdministrator from "../../../../components/@groups/administrators/UpdateAdministrator";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorGroupUpdatePage() {

    return (
        <UpdateAdministrator 
            routeType={routeTypes.admin}
        />
    )
}       